export const MANUAL_STAGE_TITLE = 'Добавлено вручную';
